import { zodResolver } from "@mantine/form";
import { vitalsEntryDataSchema } from "beitary-shared";
import { z } from "zod";

const vitalsEntryFormSchema = vitalsEntryDataSchema;

export type VitalsEntryFormValues = z.infer<typeof vitalsEntryFormSchema>;

export const rules = zodResolver(vitalsEntryFormSchema);
